import * as React from 'react';
import { useState, useEffect } from 'react';
import Offcanvas from 'react-myoneui/lib/Offcanvas';
import Button from 'react-myoneui/lib/Button';
import DropdownCommon from 'components/DropdownCommon';
import SnackBar from 'components/SnackBar';
import ls from 'localstorage-slim';
import { filterIcon, clearFormIcon } from 'constants/icons';
import { getProgramList } from 'api';
import { getAssessorPrograms } from 'api';
import { getAssignedPrograms } from 'api/tutor/program';
import { getIQVPrograms } from 'api/iqv';
import { getEQVPrograms } from 'api/eqv';
import Log from 'lib/Log';
// enable global encryption
ls.config.encrypt = true;

function ShowFilterOffCanvas(props) {
  const { triggerTitle, applyFilter, resetFilter, updateResetFilter, formCleared = () => {} } = props;
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [perPage, setPerPage] = useState(20);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [data, setData] = useState([]);
  const activeRole = JSON.parse(ls.get('activeRole'));
  const role = ls.get('role');
  const userId = ls.get('userid');
  const organisationId = ls.get('orgId');
  const [formData, setFormData] = useState({
    program: '',
  });
  const offCanvasKeyDown = (e) => e.stopPropagation();

  const handleClose = () => {
    formCleared();
    setFormData({
      program: '',
    });
  };

  const closeOffcanvas = () => {
    setShow(false);
    handleClose();
  };

  const roleFunctionMap = {
    admin: (payload) => getProgramList(payload),
    assessor: (payload) => getAssessorPrograms(payload),
    eqv: (payload) => getEQVPrograms(payload),
    iqv: (payload) => getIQVPrograms(payload),
    tutor: (payload) => getAssignedPrograms(payload),
  };

  const reLoadData = async () => {
    try {
      perPage === 20 && setData([]);
      let payload = { perPage: perPage, search: searchText, orgId: organisationId, is_published: true };
      if (role === 'tutor') {
        payload.role = activeRole?.id;
        payload.member = userId;
      }
      if (role === 'assessor') {
        payload.assessor = userId;
      } else if (role === 'iqv') {
        payload.iqv = userId;
      } else if (role === 'eqv') {
        payload.eqv = userId;
      }
      setLoading(true);
      const roleFunc = roleFunctionMap[role];
      if (roleFunc) {
        const result = await roleFunc(payload);
        if (result) {
          setData(result?.data?.data?.programs);
          setHasNextPage(result?.data.data?.meta?.hasNextPage);
        }
      }
    } catch (err) {
      Log.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show && !searchText) {
      reLoadData();
    } else if (show && searchText.length > 0) {
      setTimeout(() => {
        reLoadData();
      }, 1000);
    }
  }, [searchText, perPage, show]);

  useEffect(() => {
    if (resetFilter) {
      updateResetFilter();
      setFormData({
        program: '',
      });
    }
  }, [resetFilter]);

  return (
    <>
      <a
        onClick={() => setShow(true)}
        href="#"
        className="filter-icon"
        type="button"
      >
        {filterIcon}
        <span>{triggerTitle}</span>
      </a>
      <Offcanvas
        show={show}
        onHide={closeOffcanvas}
        placement="end"
        onKeyDown={offCanvasKeyDown}
      >
        <Offcanvas.Header
          closeButton
          backButton
        >
          <Offcanvas.Title>
            Apply Filter
            <p className="help-text w-75">Enter the name and description of the favourite report that all users will be able to access</p>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <>
            <DropdownCommon
              className="mb-4"
              name="program"
              defaultValue={formData?.program}
              items={data}
              label="Program"
              onChange={(e) => {
                setFormData({ ...formData, program: e });
              }}
              onSearch={(val) => setSearchText(val)}
              searchText={searchText}
              isLoading={loading}
              onLoadMore={() => setPerPage(perPage + 10)}
              hasMore={hasNextPage}
              showMoreBtn={true}
            />
          </>
          <div className="clear-form">
            <Button
              variant="default"
              onClick={() => {
                handleClose();
                setShow(false);
              }}
            >
              {clearFormIcon} Clear Form
            </Button>
          </div>
        </Offcanvas.Body>
        <Offcanvas.Footer>
          <Button
            variant="default"
            onClick={closeOffcanvas}
          >
            Cancel
          </Button>
          <SnackBar
            applyFilter={() => {
              setShow(false);
              return applyFilter({
                ...formData,
              });
            }}
          />
        </Offcanvas.Footer>
      </Offcanvas>
    </>
  );
}

export default ShowFilterOffCanvas;
